import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPosterOrder, IPosterOrderItem } from '../../../../../../../common/common-interfaces/poster-order';
import moment from 'moment';
import { Utility } from '../../../services/utility';
import { IStoreSettings } from '../../../../../../../common/common-interfaces/store-settings';

@Component({
    selector: 'all-reclaims',
    templateUrl: './all-reclaims.component.html',
    styleUrls: ['./all-reclaims.component.scss'],
    standalone: false
})
export class AllReclaimsComponent {
  reclaimedOrders: (IPosterOrder & any)[] = [];
  stores: IStoreSettings[];
  storesById: { [id: string]: IStoreSettings } = {};

  periodStart: Date;
  periodEnd: Date;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }

  async ngOnInit() {
    this.periodStart = moment().subtract(3, 'months').toDate();
    this.periodEnd = moment().toDate();

    this.stores = await this.api.admin().get<any>(`/stores`);

    for (let store of this.stores) {
      this.storesById[store._id] = store;
    }


    await this.fetchReclaimedOrders();
  }

  async fetchReclaimedOrders() {
    delete this.reclaimedOrders;
    this.reclaimedOrders = await this.api.admin().get<any>(`/poster-orders/reclaimed?startDate=${moment(this.periodStart).toISOString()}&endDate=${moment(this.periodEnd).toISOString()}`);
  }

}


